import { useState } from "react";
import { channelOptions, courierOptions, paymentOptions, shippingModeOptions, zoneOptions } from "../pages/orders";
import DateRangeCalendar from "./Calendar";
import { Button } from "./ui/Button";
import { Select } from "./ui/Select";

export const FilterDrawer = ({
  filters,
  onFilterChange,
  noCalendar,
  onClose,
  options
}: {
  filters: any;
  options?:any
  noCalendar?: boolean;
  onFilterChange: (key: string, value: any) => void;
  onClose: () => void;
}) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const handleChange = (key: string, value: any) => {
    setLocalFilters((prev: any) => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    Object.keys(localFilters).forEach((key) => {
      onFilterChange(key, localFilters[key]);
    });
    onClose();
  };

  const handleReset = () => {
    const resetFilters = {
      channelFilter: '',
      paymentFilter: '',
      courierFilter: '',
      shippingModeFilter: '',
      zoneFilter: '',
      statusFilter: '',
      startDate: null,
      endDate: null,
    };
    setLocalFilters(resetFilters);
    Object.keys(resetFilters).forEach((key) => {
      onFilterChange(key, resetFilters[key as keyof typeof resetFilters]);
    });
  };

  return (
    <div className=" space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Filters</h2>
      </div>

      <div className="space-y-4">
        {/* Channel Filter */}
        {options.channelOptions && (
          <div>
            <label className="block text-sm font-medium mb-1">Channel</label>
            <Select
              options={options.channelOptions}
              value={localFilters.channelFilter}
              onChange={(e) => handleChange('channelFilter', e.target.value)}
            />
          </div>
        )}

        {/* Date Range Filter */}
        {!noCalendar && (
          <div>
            <label className="block text-sm font-medium mb-1">Date Range</label>
            <div className="space-y-2">
              <DateRangeCalendar
                startDate={localFilters.startDate}
              endDate={localFilters.endDate}
              onChange={(start, end) => {
                handleChange('startDate', start);
                handleChange('endDate', end);
              }}
            />
          </div>
        </div>
        )}
        {/* Payment Filter */}
        {options.paymentOptions && (
          <div>
            <label className="block text-sm font-medium mb-1">Payment</label>
            <Select
              options={options.paymentOptions}
              value={localFilters.paymentFilter}
              onChange={(e) => handleChange('paymentFilter', e.target.value)}
            />
          </div>
        )}

        {/* Courier Filter */}
        {options.courierOptions && (
          <div>
            <label className="block text-sm font-medium mb-1">Courier</label>
            <Select
              options={options.courierOptions}
              value={localFilters.courierFilter}
              onChange={(e) => handleChange('courierFilter', e.target.value)}
            />
          </div>
        )}

        {/* Shipping Mode Filter */}
        {options.shippingModeOptions && (
          <div>
            <label className="block text-sm font-medium mb-1">Shipping Mode</label>
            <Select
              options={options.shippingModeOptions}
              value={localFilters.shippingModeFilter}
              onChange={(e) => handleChange('shippingModeFilter', e.target.value)}
            />
          </div>
        )}

        {/* Zone Filter */}
        {options.zoneOptions && (
          <div>
            <label className="block text-sm font-medium mb-1">Zone</label>
            <Select
              options={options.zoneOptions}
              value={localFilters.zoneFilter}
              onChange={(e) => handleChange('zoneFilter', e.target.value)}
            />
          </div>
        )}

        {/* Status Filter */}
        {options.statusOptions && options.statusOptions.length > 0 && (
          <div>
            <label className="block text-sm font-medium mb-1">Status</label>
            <Select
              options={options.statusOptions}
              value={localFilters.statusFilter}
              onChange={(e) => handleChange('statusFilter', e.target.value)}
            />
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex gap-3 pt-4 border-t">
        <Button onClick={handleApply} className="flex-1 bg-teal text-white">
          Apply Filters
        </Button>
        <Button variant="outline" onClick={handleReset} className="flex-1">
          Reset
        </Button>
      </div>
    </div>
  );
};